import { render, staticRenderFns } from "./PlaybackArea.vue?vue&type=template&id=2969d3bf"
import script from "./PlaybackArea.vue?vue&type=script&lang=js"
export * from "./PlaybackArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports